import { useState, useEffect } from "react";

interface TimeLeftResult {
  timeLeft: string;
  isDue: boolean;
}

export function useTimeLeft(date: Date | null): TimeLeftResult {
  const [result, setResult] = useState<TimeLeftResult>({
    timeLeft: "",
    isDue: false,
  });

  useEffect(() => {
    if (!date) {
      setResult({ timeLeft: "", isDue: false });
      return;
    }

    const updateTimeLeft = () => {
      const now = new Date();
      // Calculate the difference in milliseconds
      const difference = date.getTime() - now.getTime();

      // Determine if the callback is overdue by more than 1 hour (i.e. difference < -3600000)
      const isDue = difference < -1000;

      // Use the absolute difference for the digits display
      const absDiff = Math.abs(difference);
      const days = Math.floor(absDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (absDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((absDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((absDiff % (1000 * 60)) / 1000);

      let timeLeftStr = "";
      if (days > 0) timeLeftStr += `${days}d `;
      if (hours > 0 || days > 0) timeLeftStr += `${hours}h `;
      if (minutes > 0 || hours > 0 || days > 0) timeLeftStr += `${minutes}m `;
      timeLeftStr += `${seconds}s`;

      if (isDue) {
        timeLeftStr = `-${timeLeftStr}`;
      }
      setResult({ timeLeft: timeLeftStr.trim(), isDue });
    };

    updateTimeLeft();
    const timerId = setInterval(updateTimeLeft, 1000);

    return () => clearInterval(timerId);
  }, [date]);

  return result;
}
